export default "__VITE_ASSET__DdJyGkf8__"